<template>
	<pre v-html="$t('terms.legal_indication4')"></pre>
</template>

<script>
export default {
	name: 'LegalIndication4',
};
</script>

<style scoped></style>
